import React from "react";
import styled from "styled-components";

import DeleteForeverRoundedIcon from "@mui/icons-material/DeleteForeverRounded";

import SelectServiceType from "../NewDashboard/Commons/SelectServiceType";
import HorizontalLine from "./HorizontalLine";

import Colors from "../../Constants/Colors";
import TextStyles from "../../Constants/TextStyles";

const ServiceItemContainer = styled.div`
  margin-top: 1rem;
  font-size: 0.875rem;
  color: ${Colors.font1};

  label {
    margin-bottom: 0.5rem;
  }

  input {
    max-width: 85%;
    margin: 0;
  }

  .deleteBtn {
    display: none;
    cursor: pointer;
    color: ${Colors.font2};
  }

  &:hover .deleteBtn {
    display: block;
  }
`;

const RateContainer = styled.div`
  /* QA wants the same height that's why weird 13.92px given */
  padding: 13.92px 16px;
  border: 1px solid ${Colors.borderInput};
  border-radius: 0.75rem;

  &:hover {
    border: 1px solid ${Colors.primary};
  }

  input {
    width: 80px;
  }
`;

function ProjectServiceItem({
  index,
  fields,
  register,
  Controller,
  control,
  remove,
  currencySymbol,
  errors,
}) {
  return (
    <ServiceItemContainer>
      <div className="mb-3">
        <label htmlFor="service">Service Name</label>

        <div className="d-flex align-items-center justify-content-between">
          <TextStyles.InputRectangle
            id="service"
            type="text"
            placeholder="Service name"
            {...register(`servicesList.${index}.service_name`, {
              required: "Service name is required.",
              validate: (val) =>
                val.trim() !== "" || "Service name is required.",
              minLength: {
                value: 3,
                message: "Minimum 3 characters required.",
              },
              maxLength: {
                value: 50,
                message: "Maximum 50 characters allowed.",
              },
            })}
          />

          {fields.length > 1 && (
            <DeleteForeverRoundedIcon
              className="deleteBtn"
              onClick={() => remove(index)}
            />
          )}
        </div>

        {errors.servicesList &&
          errors.servicesList[index] &&
          errors.servicesList[index].service_name && (
            <TextStyles.InValidFeedback className="mt-2">
              {errors.servicesList[index].service_name.message}
            </TextStyles.InValidFeedback>
          )}
      </div>

      <div className="mb-3">
        <label htmlFor="rate">Rate</label>

        <div className="d-flex gap-4 flex-wrap align-items-center">
          <RateContainer>
            <span>{currencySymbol}</span>
            <input
              type="number"
              id="rate"
              step={0.01}
              placeholder="00.00"
              {...register(`servicesList.${index}.service_rate`, {
                required: "Rate is required.",
                min: {
                  value: 1,
                  message: "Minimum value should be 1.",
                },
              })}
            />
          </RateContainer>

          <Controller
            control={control}
            defaultValue="Flat fee"
            name={`servicesList.${index}.service_rate_type`}
            render={({ field: { onChange, value } }) => (
              <SelectServiceType
                placeholder="Select"
                onChange={onChange}
                defaultValue={value}
              />
            )}
          />
        </div>

        {errors.servicesList &&
          errors.servicesList[index] &&
          errors.servicesList[index].service_rate && (
            <TextStyles.InValidFeedback className="mt-2">
              {errors.servicesList[index].service_rate.message}
            </TextStyles.InValidFeedback>
          )}
      </div>

      <div className="mb-3">
        <label htmlFor="description" className="mb-2">
          Description
        </label>

        <TextStyles.Textarea
          rows={4}
          id="description"
          placeholder="Add a note..."
          {...register(`servicesList.${index}.desc`)}
        />
      </div>

      <HorizontalLine className="mb-3" color={Colors.font2} />
    </ServiceItemContainer>
  );
}

export default ProjectServiceItem;
